import {Container} from "pixi.js";

export class Pivot {

    static centerPivot(sprite: Container, byX: boolean = true, byY: boolean = true) {
        byX && (sprite.pivot.x = Math.floor(sprite.width * .5));
        byY && (sprite.pivot.y = Math.floor(sprite.height * .5));
    }
}
